export type ProductFileType = {
    anchorText: string;
    position: number;
    url: string;
    urlToOpen: string;
    type: ProductFileTypeType;
};

export type ProductFileTypeType = 'ManualFile' | 'RecipeFile' | 'ManualRecipeFile' | null;

export const isProductFileTypeType = (value: string): value is Exclude<ProductFileTypeType, null> => {
    return value === 'ManualFile' || value === 'RecipeFile' || value === 'ManualRecipeFile';
};
